<template>
  <Modal ref="modal" title="Estorno de fatura" @cancel="close">
    <div class="modal-container">
      <div class="inputs-row">
        <Input legend="Razão para estorno" :modelValue="observacao" @update:modelValue="$event => observacao = $event"
          class="input-full" :disabled="loading" />
      </div>

      <div class="inputs-row">
        <div class="checkbox">
          <label>
            Forçar estorno?
            <input type="checkbox" v-model="force" :disabled="loading" />
            <span></span>
          </label>
        </div>
      </div>

      <div class="buttons">
        <Button @handle:click="close" text="Cancelar" color="danger" :disabled="loading" />
        <Button @handle:click="handleReversal" text="Confirmar" color="primary" :disabled="loading" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Input from 'core/Input'
import Button from 'core/Button'
import Reload from 'icons/Reload'
import ArrowLeftBottom from 'icons/ArrowLeftBottom'

export default {
  name: 'ReversalModal',
  components: {
    Modal,
    Input,
    Button,

    Reload,
    ArrowLeftBottom,
  },
  props: {

  },
  data() {
    return {
      fatura: null,
      observacao: '',
      force: false,
      loading: false,
    }
  },
  methods: {
    open(fatura) {
      this.fatura = fatura

      this.$refs.modal.open()
    },
    close() {
      this.fatura = null
      this.observacao = ''
      this.force = false
      this.loading = false

      this.$refs.modal.close()
    },
    async handleReversal() {
      this.loading = true

      if (!this.observacao) {
        this.$toasted.info('Preencha a razão do estorno!', {
          position: 'top-right',
          icon: 'fa-time',
        })

        this.loading = false

        return
      }

      this.$toasted.info('Verificando aulas do aluno...', {
        position: 'top-right',
        icon: 'fa-time',
      })

      const data = {
        fatura: this.fatura.id,
        schema: this.fatura.autoescola,
        observacao: this.observacao,
        force: this.force
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/estorno`, data)
        .then(res => {
          this.$toasted.success(res.body.mensagem, {
            position: 'top-right',
            icon: 'fa-check',
          })

          this.close()

          this.$emit('reversed')
        })
        .catch(err => {
          this.$toasted.error(err.body.mensagem, {
            position: 'top-right',
            icon: 'fa-close',
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 40vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .inputs-row {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .input-full {
      flex: 1;
    }

    .checkbox {
      label {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
        font-size: 1rem;
        font-weight: 600;
        line-height: 19.1px;
        color: #606264;
        cursor: pointer;

        input[type="checkbox"] {
          display: none;
        }

        span {
          position: relative;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          border: 2px solid #DFDCDC;
          border-radius: 2px;
          background-color: #FAFAFA;
          transition: background-color 0.2s, border-color 0.2s;
        }

        input[type="checkbox"]:checked+span {
          background-color: #1C2D5A;
        }

        input[type="checkbox"]:checked+span::after {
          content: '✓';
          color: white;
          font-size: 8px;
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .buttons {
    align-self: flex-end;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>